<div class="maintenance-tab">
  <div class="row">
    <!-- Left Column -->
    <div class="col-md-6">
      <div class="form-group">
        <label class="col-md-6 control-label" for="tractorStatus">TRACTOR STATUS</label>
        <div class="col-md-6 inputSpace">
          <span [ngClass]="getStatusPillClass()">
            {{ getTractorStatusLabel() }}
          </span>
        </div>
      </div>

      <div class="form-group">
        <label class="col-md-6 control-label" for="nextServiceDate">NEXT SERVICE DATE</label>
        <div class="col-md-6 inputSpace">
          <input
            id="nextServiceDate"
            name="nextServiceDate"
            type="text"
            class="form-control"
            [inputMask]="dateInputMask"
            placeholder="mm/dd/yyyy"
            [(ngModel)]="tractor.nextServiceDate"
            (ngModelChange)="onFieldChange()"
            [disabled]="!isEditMode"
          />
        </div>
      </div>
    </div>
  </div>
</div>

